<template>
  <g>
    <rect
      x="10.1875"
      y="10.4912"
      width="7.27273"
      height="3.50877"
      rx="0.4"
      :fill="iconColor"
    />
    <path
      d="M22.4315 11.9347C22.6296 12.0948 22.6296 12.3968 22.4315 12.5569L16.8889 17.037C16.6273 17.2484 16.2375 17.0622 16.2375 16.7259L16.2375 7.76576C16.2375 7.42942 16.6273 7.24325 16.8889 7.45468L22.4315 11.9347Z"
      :fill="iconColor"
    />
    <path
      d="M14.0769 7.78435V5C14.0769 4.44772 13.6292 4 13.0769 4H4C3.44772 4 3 4.44772 3 5V19C3 19.5523 3.44771 20 4 20H13.0769C13.6292 20 14.0769 19.5523 14.0769 19V16.8557"
      :stroke="iconColor"
      stroke-width="1.8"
    />
  </g>
</template>

<script>
export default {
  props: {
    iconColor: {
      type: String,
      default: "#3c3c3c"
    }
  }
};
</script>
